import GoogleTagManager from '@redux-beacon/google-tag-manager'
import { createMiddleware } from 'redux-beacon'
import eventsMap from './Analytics.events'
import withMetaData from './Analytics.meta'
import { createEventsMap } from './Analytics.utils'

const gtmMiddleware = (services) => createMiddleware(
  createEventsMap(eventsMap, withMetaData(services)),
  GoogleTagManager(),
)

export default gtmMiddleware
